/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
import z from 'zod';
// Why an ignored concern was kept as is; the PA Agent reads it on later reviews.
export const vettingDismissalCategories = [
    'agent_wrong',
    'intentional',
    'accepted_risk',
    'fix_later',
];
// Addressed: the input was fixed. Ignored: kept as is, for one of the dismissal categories.
export const dismissVettingConcernPayloadSchema = z.discriminatedUnion('status', [
    z.strictObject({ status: z.literal('addressed'), reason: z.string().trim().min(1) }),
    z.strictObject({
        status: z.literal('ignored'),
        category: z.enum(vettingDismissalCategories),
        reason: z.string().trim().min(1),
    }),
]);
//# sourceMappingURL=bid-request-vetting.js.map